<style scoped lang="scss" type="text/scss">
    .status-card-container {
        height: 8rem;
        background-color: #F4F4F4;
        border-radius: .15rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: .8rem;

        &.error-tag {
            .icon-container {
                color: #C55;
            }
        }

        &.success-tag {
            .icon-container {
                color: #3faa8e;
            }
        }

        .icon-container {
            height: 3.8rem;
            font-size: 2.5rem;
            display: flex;
            justify-content: center;
            align-items: flex-end;
        }

        .text-container {
            height: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: .8rem;
            color: #999;
            text-align: center;

            span {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                max-height: 2.5rem;
                overflow: hidden;
            }
        }
    }
</style>

<template>
    <border-active-block class="status-card-container"
                         :class="{'success-tag': finished, 'error-tag': !finished}" @click.native="redirect">
        <div class="icon-container">
            <i class="icon" v-html="statusIcon"></i>
        </div>
        <div class="text-container">
            <span>{{ title }}</span>
        </div>
    </border-active-block>
</template>

<script>
    import BorderActiveBlock from '../../../../../components/border-active-block/index';
    import _ from 'lodash';

    export default {
        name: '',
        components: {
            BorderActiveBlock
        },
        props: {
            info: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        computed: {
            finished () {
                return _.get(this.info, 'finished', false);
            },
            title () {
                return _.get(this.info, 'title', '');
            },
            routeName () {
                return _.get(this.info, 'route_name', '');
            },
            statusIcon () {
                if (this.finished) {
                    return '&#xe60e;';
                } else {
                    return '&#xe673;';
                }
            }
        },
        methods: {
            redirect () {
                this.$router.push({
                    name: this.routeName
                });
            }
        }
    };
</script>
